module.exports = __webpack_public_path__ + "img/banner2.75b330b.png";